import type { ColorScheme, PrimaryColor } from '../../styles/theme/types'
import type { Settings } from '../../types/settings'
import { siteConfig } from '@axilon-apps/libs-ui-core'

export function applyDefaultSettings(settings: Partial<Settings>): Settings {
  return {
    colorScheme: siteConfig.style.colorScheme as ColorScheme,
    primaryColor: siteConfig.style.primaryColor as PrimaryColor,
    direction: 'ltr',
    ...settings
  }
}
